/** Order details rendered on the song confirmation + journey pages. */
export interface SongOrderSummary {
  /** Person the song is for, e.g. "Jean Grey". */
  recipientName: string;
  /** Relationship to the recipient, e.g. "Girlfriend". */
  relationship: string;
  /** Occasion the song celebrates, e.g. "Anniversary". */
  occasion: string;
  /** Music style / genre, e.g. "Jazz". */
  musicStyle: string;
  /** Email the order confirmation was sent to. */
  confirmationEmail: string;
}

/** "How did you hear about us?" answers, in the order they appear in the design. */
export const HEAR_ABOUT_US_OPTIONS = [
  "receivedASong",
  "previousCustomer",
  "someoneSharedASong",
  "youtube",
  "facebook",
  "pinterest",
  "friendOrFamily",
  "instagram",
  "tiktok",
  "snapchat",
  "googleSearch",
  "noneOfTheAbove",
] as const;

export type HearAboutUsOption = (typeof HEAR_ABOUT_US_OPTIONS)[number];

/** Ordered stages of the song journey timeline. */
export const SONG_JOURNEY_STAGES = [
  "requestReceived",
  "lyricsInProgress",
  "musicProduction",
  "finalMastering",
  "delivered",
] as const;

export type SongJourneyStage = (typeof SONG_JOURNEY_STAGES)[number];
